import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CurrencySymbolPipe, EgDatePipe, EgFindPipe, EgNumberPipe, SanitizeHtmlPipe, TruncatePipe } from './pipes';
import { TranslocoModule } from '@jsverse/transloco';

const PIPES = [CurrencySymbolPipe, EgDatePipe, EgFindPipe, EgNumberPipe, SanitizeHtmlPipe, TruncatePipe];

@NgModule({
  imports: [CommonModule, TranslocoModule],
  declarations: [...PIPES],
  exports: [...PIPES],
  providers: [...PIPES],
})
export class SharedPipesModule {}
